import React from 'react';
import ConfirmDialog from '../../ui/ConfirmDialog';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  /** Peut contenir du balisage (nos propres traductions, jamais une saisie). */
  message: string;
  /** Seconde ligne, en gris : ce que l'action fait exactement. */
  description?: string;
  confirmLabel: string;
  destructive?: boolean;
  loading?: boolean;
  onConfirm: () => void;
}

/**
 * Confirmation des actions en masse du planning — variante à message BALISÉ
 * de `ui/ConfirmDialog` (une seule implémentation, pas deux dialogs jumeaux).
 *
 * Le balisage n'est accepté que parce que `message` vient exclusivement de
 * nos traductions ; pour un texte qui contient une saisie utilisateur (nom
 * d'équipe, d'événement…), utiliser `ConfirmDialog` directement.
 */
const ConfirmActionDialog: React.FC<Props> = ({ message, ...rest }) => (
  <ConfirmDialog
    {...rest}
    message={<span dangerouslySetInnerHTML={{ __html: message }} />}
  />
);

export default ConfirmActionDialog;
